// import CustomerTab from '../../components/CustomerTab';
import CustomerHeader from '../../components/CustomerHeader';
import EmployeesTable from '../../components/manager/EmployeesTable';
import ManagerSidebar from '../../components/manager/ManagerSidebar';



const EmployeesScreen = () => {
  return (
    <>
        <section className='dashboard-container flex '>
          <aside className=''>
              <ManagerSidebar />
          </aside>
          <main className='main-container mb-32'>
              <CustomerHeader orderTitle={'Employees'} orderSubtitle={'Manage employees'} showEmployeesButton={true}/>

            <section className='mt-20 flex gap-4'>
              <section>
                <EmployeesTable/>
              </section>
            </section>
          </main>
        </section>
    </>
    
  )
}

export default EmployeesScreen